import * as React from "react";
import {
  Text,
  Image,
  StyleSheet,
  View,
  Modal,
  TouchableOpacity,
  Dimensions,
  Platform,
  Button,
} from "react-native";
import { Video, ResizeMode, AVPlaybackStatus } from "expo-av";
import { useRoute } from "@react-navigation/native";
import { ScrollView } from "react-native-gesture-handler";
import GlobalStyles from "../../components/GlobalStyles";
// import { useState } from "react"; a part of cleaner code
import CharitySelectPopup from "../../components/CharitySelectionPopup";
import { useSelector } from "react-redux";
// import { enableCharityThanksModal } from "../redux/actions/UIStateActions";
import UnderLine from "../../components/AnimatedUnderLine";
import MenuBar from "../../components/headers/MenuBar";
import StatusBar from "../../components/headers/StatusBar";
import FooterBarWide from "../../components/footerBarWide";
import { useNavigation } from "@react-navigation/native";
import { updateCharity } from "../../redux/actions/CharityActions";
import { user_force_refresh } from "../../redux/actions/UserActions";
import BackButton from "../../components/BackButton";
import GenericButton from "../../components/GenericButton.js"

function selectCharity(id, lastUpdate, navigation) {
  let date;
  let today = new Date();
  lastUpdate !== undefined ? (date = Date.parse(lastUpdate)) : (date = 0);
  let dateDiff = Math.ceil((today - date) / (1000 * 3600 * 24));
  let dateLeft = 31 - dateDiff;
  if (dateDiff > 31) {
    updateCharity(id);
    user_force_refresh();
    //enableCharityThanksModal()}
    navigation.navigate("DonateNotificationConfirm");
  } else {
    user_force_refresh();
    navigation.navigate("DonateNotificationFail", { daysLeft: dateLeft });
  }
}

function myReadyForDisplay() { }

export default function SpendingInsightsDetailScreen() {
  const subscriptionDetails = useSelector(
    (state) => state.user.userData.subscriberDetails
  );
  const selectedCharity = useSelector(
    (state) => state.user.userData.subscriberDetails.charityId
  );
  var lastUpdate = undefined;
  if (subscriptionDetails !== undefined) {
    lastUpdate = useSelector(
      (state) => state.user.userData.subscriberDetails.last_charity_upDate
    );
  }
  if (lastUpdate === undefined) {
    lastUpdate = "2000-01-01";
  }
  var modalVisible = useSelector((state) => state.uistate.charityThankYouModal);
  const user = useSelector((state) => state.user.userData);
  const navigation = useNavigation();
  // const [modalVisible, setModalVisible] = useState(false); a part of cleaner code
  const route = useRoute();
  const win = Dimensions.get("window");
  const video = React.useRef(null);
  const [status, setStatus] = React.useState({});
  return (
    <View style={GlobalStyles.containerW}>
      <ScrollView style={styles.scrollArea}>
        {win.width > 768 ? (
          <View style={GlobalStyles.fullHeaderBarY}>
            <MenuBar data="5" />
            <View style={GlobalStyles.topHeaderTitelContainerForWeb}>
              <View style={[GlobalStyles.headerContainerKLYellow, { alignSelf: "flex-start" }]}>
                <View style={GlobalStyles.headerTextYellowForweb}>
                  <View style={GlobalStyles.backIconContainerForWeb} >
                    <BackButton />
                  </View>
                  <View>
                    <Text style={GlobalStyles.headingStyle}>  {route.params.charity.name}</Text>
                    <Text style={GlobalStyles.subheaderStyleWeb}>  {route.params.charity.categoryName}</Text>
                  </View>
                </View>
              </View>
            </View>
          </View>
        ) : (
          <View style={GlobalStyles.fullHeaderBarW}>
            <StatusBar data="BM" />
            <View style={GlobalStyles.headerContainerKL}>
              <View style={GlobalStyles.headerTextBoxTwoDonate}>
                <View style={GlobalStyles.headerTextColApp}>
                  <Text style={GlobalStyles.headingStylePercent}>
                    {route.params.charity.name}
                  </Text>
                  <Text style={GlobalStyles.subheaderStyleDonate}>
                    {route.params.charity.categoryName}
                  </Text>
                </View>
                <View style={styles.imageThumbnailPadding}>
                  <Image
                    style={styles.imageThumbnail}
                    source={{ uri: route.params.charity.imageUrl }}
                  />
                </View>
              </View>
            </View>
          </View>
        )}
        {/* <View style={GlobalStyles.bodyContainer}> */}
        <View style={GlobalStyles.adjustableBodyContainer}>
          {win.width > 768 ? (
            <View style={styles.bodyMiddleCols}>
              <View style={styles.bodyMiddleColsA}>
                <Image
                  style={styles.imageThumbnailWide}
                  source={{ uri: route.params.charity.imageUrl }}
                />
              </View>
              <View style={styles.bodyMiddleColsB}>
                <Text style={styles.description}>
                  {route.params.charity.description}
                </Text>
              </View>
            </View>
          ) : (
            <Text style={styles.description}>
              {route.params.charity.description}
            </Text>
          )}
          <View>
            {route.params.charity.id === selectedCharity ? (
              <TouchableOpacity
                style={GlobalStyles.linkStyle}
                activeOpacity={0.5}
              >
                <Text style={GlobalStyles.TextStyleLink}>SELECTED</Text>
                <UnderLine />
              </TouchableOpacity>
            ) : (
              <TouchableOpacity
                style={GlobalStyles.linkStyle}
                activeOpacity={0.5}
                onPress={() =>
                  selectCharity(route.params.charity.id, lastUpdate, navigation)
                }
              >
                <Text style={GlobalStyles.TextStyleLink}>SELECT</Text>
                <UnderLine />
              </TouchableOpacity>
            )}
          </View>

          {route.params.charity.videoURL === "NA" ? (
            <></>
          ) : (
            <View style={styles.containerVideo}>
              <Video
                ref={video}
                style={styles.video}
                videoStyle={styles.videoVid}
                source={{
                  uri: route.params.charity.videoURL,
                }}
                useNativeControls={true}
                resizeMode={"contain"}
                isLooping={false}
                shouldPlay={false}
                onPlaybackStatusUpdate={(status) => setStatus(() => status)}
                onReadyForDisplay={(videoData) => {
                  //videoData.naturalSize.height= 120
                  //videoData.naturalSize.width= 150
                }}
              />
              <View style={styles.buttons}>
                {/* This commented part can be removed in 15/10/23 */}
                {/* <TouchableOpacity
                  style={[
                    styles.submitBlackButtonStyle,
                    { borderColor: "black" },
                  ]}
                  onPress={() =>
                    status.isPlaying
                      ? video.current.pauseAsync()
                      : video.current.playAsync()
                  }
                >
                  <Text style={[styles.TextButtonStyle, { color: "black" }]}>
                    {status.isPlaying ? "Pause" : "View Video"}
                  </Text>
                </TouchableOpacity> */}
                <GenericButton
                  buttonText={status.isPlaying ? "Pause" : "View Video"}
                  onPress={() =>
                    status.isPlaying
                      ? video.current.pauseAsync()
                      : video.current.playAsync()
                  }
                />
              </View>
            </View>
          )}

          {Platform.OS != "web" ? (
            <View>
              <Modal
                transparent={false}
                animationType="fade"
                visible={modalVisible}
              >
                <CharitySelectPopup visible={modalVisible} />
              </Modal>
            </View>
          ) : (
            <></>
          )}
        </View>
      </ScrollView>
      <View style={GlobalStyles.webFooter}>
        {win.width > 768 ? <FooterBarWide /> : null}
      </View>
    </View>
  );
}

const videoWidth = Platform.OS != "web" ? 375 : 854
const videoHeight = Platform.OS != "web" ? 210 : 480

const styles = StyleSheet.create({
  video: {
    alignSelf: "center",
    width: videoWidth,
    height: videoHeight,
    // web width: 854,
    // web height: 480,
    marginBottom: 20,
  },
  videoVid: {
    width: "100%",
    height: "100%",
  },
  containerVideo: {
    marginTop: 25,
    flex: 1,
    justifyContent: "center",
    //borderColor: "#000000",
    // borderWidth: 1,
  },
  submitBlackButtonStyle: {
    borderRadius: 50,
    borderColor: "#ffffff",
    borderWidth: 1,
    justifyContent: "center",
    height: 35,
    paddingLeft: 14,
    paddingRight: 14,
    width: 320,
    alignSelf: "center",
    //marginLeft: 35
  },
  TextButtonStyle: {
    color: "#ffffff",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 13,
    lineHeight: 14,
  },
  bodyMiddleCols: {
    //flex: 1,
    flexDirection: "row",
    alignItems: "flex-start",
  },
  bodyMiddleColsA: {
    flex: 1,
    paddingRight: 20,
  },
  bodyMiddleColsB: {
    flex: 3,
    //paddingBottom: 20,
  },
  imageThumbnail: {
    height: 70,
    width: "100%",
    resizeMode: "contain",
    margin: 1,
  },
  imageThumbnailWide: {
    height: 200,
    width: "100%",
    resizeMode: "contain",
  },
  scrollArea: {
    backgroundColor: "#ffffff",
  },
  description: {
    fontFamily: "montserrat-regular",
    fontSize: 14,
    textAlign: "left",
    marginBottom: 5,
    lineHeight: 20,
    paddingTop: 20,
  },
  headerImageBox: {
    flex: 1,
    alignContent: "flex-start",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    paddingRight: 150,
  },
  imageThumbnailPadding: {
    //paddingRight: 30,
    minWidth: 70,
    flex: 1,
    justifyContent: "center",
  },
  bodyStyle: {
    fontFamily: "montserrat-regular",
    fontSize: 12,
    textAlign: "left",
    marginBottom: 5,
  },
});
